import React, {FC} from 'react';
import dead from '../../assets/images/icon-page/dead.png';


const DeadIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'Dead Icon'}) => {
    return (
        <img
            src={dead}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default DeadIcon;
